import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { formatDate } from '@/utils/formatDate';

type Props = {
  firstName?: string;
  lastName?: string;
  subtitle?: string;
};

function getInitials(first?: string, last?: string): string {
  return ((first?.[0] ?? '') + (last?.[0] ?? '')).toUpperCase() || '?';
}

function getGreetingKey(): string {
  const h = new Date().getHours();
  if (h < 12) return 'dashboard.greetingMorning';
  if (h < 20) return 'dashboard.greetingAfternoon';
  return 'dashboard.greetingEvening';
}

export default function GreetingCard({ firstName, lastName, subtitle }: Props) {
  const { t } = useTranslation();
  const greetKey = getGreetingKey();
  const todayLabel = formatDate(new Date().toISOString(), {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });

  return (
    <Card>
      <CardContent className="flex items-center gap-4 py-6">
        <Avatar className="size-14 shrink-0">
          <AvatarFallback className="bg-primary/10 text-primary text-lg font-semibold">
            {getInitials(firstName, lastName)}
          </AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
            {todayLabel}
          </p>
          <h2 className="mt-0.5 truncate text-xl font-semibold text-foreground">
            {t(greetKey, { defaultValue: 'Hola' })}
            {firstName ? `, ${firstName}` : ''}
          </h2>
          {subtitle && (
            <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
